import client from '@/api/client.js'
//import store from "@/store";

export default {
    methods: {
        //NOT USED CURRENTLY
        async getQrLink(machineId) {
            var meta = {
                clientApiMethod: 'Link',
                input: { machineId: machineId },
            }
            var response = await client()
                .get("/api2/qr/Link/" + machineId, { meta: meta });
            return response.data;
        },

        async generateQrCodeList(count) {
            var meta = {
                clientApiMethod: 'generateQrCodeList',
                input: { count: count },
            }
            var response = await client()
                .get(`/api2/qr/CreateList?count=${count}`, { meta: meta });
            return response.data;
        },
    }
}